export const KEY_SHORTFORM_MAP = {
  command: "\u2318",
  escape: "esc",
  control: "ctrl",
  option: "opt",
  return: "enter",
};

export const MAC_TO_WINDOWS_KEYS_MAP = {
  option: "alt",
  command: "ctrl",
  return: "enter",
  delete: "backspace",
};

export const OS = { mac: "macOS", windows: "Windows" };

export const FULL_SHORTCUTS_LINK_PROP_NAME = "fullShortcutsLink";

export const TOOLTIP_CONTENT = {
  "\u2318": "command",
  esc: "escape",
  ctrl: "control",
  opt: "option",
  backspace: "delete",
};
